import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { getCode } from 'app/utils/method';
import { TripAttributesGps } from '../dto/visit-gps.interface';

/**
 * Route User Cell Renderer
 *
 * Renders route, user, and responsible information using UserRouteDisplayComponent
 *
 * @example
 * ```typescript
 * {
 *   field: 'subRoute',
 *   headerName: 'Ruta - Usuario',
 *   cellRenderer: RouteUserCellRendererComponent,
 *   minWidth: 250
 * }
 * ```
 */
@Component({
  selector: 'app-route-user-cell-renderer',
  standalone: true,
  imports: [CommonModule, UserRouteDisplayComponent],
  template: `
    <app-user-route-display
      [routeData]="{
        routeName: params.data?.subRoute?.name ?? '-',
        externalKeys: {
          code: getCode(params.data?.subRoute) ?? '-'
        }
      }"
      [userData]="{
        name: params.data?.user?.user_login?.username ?? '-',
        username: params.data?.user?.user_login?.username ?? '-'
      }"
      [displayMode]="'detailed'"
      [showRouteCode]="true"
      [showUser]="true"
      [showResponsible]="false"
      [showUserIcon]="true"
      [userIconDefault]="'location_on'"
      [userIconHover]="'person_pin_circle'"
      [userIconTooltip]="'Ver en mapa'"
      (onUserIconClickEvent)="handleUserIconClick()">
    </app-user-route-display>
  `,
})
export class RouteUserCellRendererComponent implements CellRenderer<TripAttributesGps> {
  @Input() params!: CellRendererParams<TripAttributesGps>;
  getCode = getCode;

  handleUserIconClick(): void {
    this.params.handleUserIconClick?.(this.params.data);
  }
}
